import * as React from 'react';
import * as I18n from 'i18n-js';
import { useViewTracking } from '@reverbdotcom/commons/dist/use_tracking';
import { experiments } from '../shared/constants';
import { MParticleEventName } from '@reverbdotcom/commons/dist/elog/mparticle_types';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/dist/elog/mparticle';
import { useUser, useExpEnabled } from '@reverbdotcom/commons/dist/user_hooks';

const COMPONENT_NAME = 'AffirmCartOptionText';

export function AffirmCartOptionText() {
  const user = useUser();
  const affirmExpEnabled = useExpEnabled(experiments.AFFIRM_CALLOUTS_BATCH1);
  const mParticleViewData = {
    componentName: COMPONENT_NAME,
    eventName: MParticleEventName.ComponentView,
    experiments: formatExperimentsForEventAttributes(user, [
      experiments.AFFIRM_CALLOUTS_BATCH1,
    ]),
  };

  useViewTracking(mParticleViewData, true);

  if (affirmExpEnabled) {
    return (
      <>
        {I18n.t('discovery.cart.buyNowPayOverTime')}
        <p className="mb-0 size-90 opacity-60">
          {I18n.t('discovery.cart.makeMonthlyPayments')}
        </p>
      </>
    );
  }
  return I18n.t('discovery.cart.buyWithAffirmDefaultText');
}
export default AffirmCartOptionText;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/cart/affirm_cart_option_text.tsx